import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { SITE } from "../lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#11171A] text-[#F4EFE6] border-t border-[#F4EFE6]/10 mt-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-20 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-4">
            <img src={SITE.logo} alt="Upsurge Strategic Land" className="h-20 w-20 object-contain" style={{ filter: "brightness(0) saturate(100%) invert(72%) sepia(36%) saturate(490%) hue-rotate(8deg) brightness(92%) contrast(86%)" }} />
            <div>
              <div className="font-display text-3xl text-[#F4EFE6]">UPSURGE</div>
              <div className="text-[11px] tracking-[0.32em] uppercase text-[#C9A24B] font-semibold mt-1">Strategic Land Ltd</div>
            </div>
          </div>
          <p className="font-display text-2xl md:text-3xl leading-tight mt-8 text-[#F4EFE6]/95 max-w-md">
            Unlocking the <span className="italic-gold">true potential</span> of British land — patiently, professionally, and at our cost.
          </p>
        </div>

        <div className="lg:col-span-3">
          <div className="overline mb-5">Explore</div>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-link-home" to="/" className="hover:text-[#C9A24B] transition-colors">Home</Link></li>
            <li><Link data-testid="footer-link-about" to="/about" className="hover:text-[#C9A24B] transition-colors">About</Link></li>
            <li><Link data-testid="footer-link-services" to="/services" className="hover:text-[#C9A24B] transition-colors">Services</Link></li>
            <li><Link data-testid="footer-link-projects" to="/projects" className="hover:text-[#C9A24B] transition-colors">Projects</Link></li>
            <li><Link data-testid="footer-link-sell" to="/sell-your-land" className="hover:text-[#C9A24B] transition-colors">Sell Your Land</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-[#C9A24B] transition-colors">Contact</Link></li>
            <li><Link data-testid="footer-link-insights" to="/insights" className="hover:text-[#C9A24B] transition-colors">Insights</Link></li>
            <li><Link data-testid="footer-link-watch" to="/watch" className="hover:text-[#C9A24B] transition-colors">Landowner Watch</Link></li>
            <li><Link data-testid="footer-link-appraisal" to="/appraisal" className="hover:text-[#C9A24B] transition-colors">Free Appraisal</Link></li>
            <li><Link data-testid="footer-link-privacy" to="/privacy" className="hover:text-[#C9A24B] transition-colors">Privacy</Link></li>
            <li><Link data-testid="footer-link-unsubscribe" to="/unsubscribe" className="hover:text-[#C9A24B] transition-colors">Unsubscribe</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="overline mb-5">Get in touch</div>
          <ul className="space-y-4 text-sm">
            <li className="flex gap-3"><MapPin size={16} className="mt-1 text-[#C9A24B]" /><span data-testid="footer-address">{SITE.address}</span></li>
            <li className="flex gap-3"><Mail size={16} className="mt-1 text-[#C9A24B]" /><a data-testid="footer-email" href={`mailto:${SITE.email}`} className="hover:text-[#C9A24B]">{SITE.email}</a></li>
            <li className="flex gap-3"><Phone size={16} className="mt-1 text-[#C9A24B]" /><a data-testid="footer-phone" href={`tel:${SITE.phoneIntl}`} className="hover:text-[#C9A24B]">{SITE.phone}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#F4EFE6]/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-[#F4EFE6]/55">
          <div>© {new Date().getFullYear()} Upsurge Strategic Land Ltd. Registered in {SITE.jurisdiction}. Company No. <span data-testid="footer-company-number" className="text-[#F4EFE6]/80">{SITE.companyNumber}</span>.</div>
          <div>Registered Office: {SITE.address}</div>
        </div>
      </div>
    </footer>
  );
}
